module.exports = __webpack_public_path__ + "static/images/14c2477bae1418982e6bb45a8dbea15a.svg";